export enum JobOfferStatus {
  draft = "draft",
  open = "open",
  closed = "closed",
  cancelled = "cancelled",
}
